import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { GrCloudDownload } from "react-icons/gr";
import { AiOutlineCloudUpload } from "react-icons/ai";

export default function BulkImport({ content, onClick }) {
  return (
    <div>
      <div className="group relative cursor-pointer" onClick={onClick}>
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content={`Bulk ${content}`}
          className="text-sm bg-gray-300 text-blue-700 shadow-sm font-semibold rounded-md px-2 py-2 flex gap-2 border-1 border-y-sky-950 items-center justify-center text-center hover:text-white hover:bg-gray-700 transition-colors"
        >
          <GrCloudDownload size={18} />
          Bulk {content}
        </div>
      </div>
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
      />
    </div>
  );
}

export const UploadModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
      <div className="bg-white w-1/2  rounded-md shadow-lg">
        {/* Header */}
        <div className="border-b p-4">
          <h2 className="text-lg font-semibold text-gray-800">
            Import Buyer Details
          </h2>
        </div>

        {/* Upload Box */}
        <div className="p-6 flex flex-col items-center justify-center">
          <div className="w-full mx-5 border-2 border-dashed border-gray-300 rounded-md p-8 text-center">
            <AiOutlineCloudUpload className="text-5xl text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600">Select a file or drag and drop here</p>
            <p className="text-gray-400 text-sm mb-4">
              file size no more than 10 MB
            </p>
            <button className="text-blue-600 border border-blue-600 px-4 py-1 rounded hover:bg-blue-50 transition">
              SELECT FILE
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t p-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-1 border rounded text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onClose}
            className="px-4 py-1 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};
